// extracted by mini-css-extract-plugin
export var wrapper = "index-module--wrapper--2q246";
export var heading = "index-module--heading--3Wl6d";